import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MutasiAntarCounterFormPage } from './mutasi-antar-counter-form.page';

const routes: Routes = [
  {
    path: '',
    component: MutasiAntarCounterFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MutasiAntarCounterFormPageRoutingModule {}
